var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pts-holder"},[_c('div',{attrs:{"id":"ptsCanvas"},on:{"click":function($event){return _vm.$emit('toggleDarkmode')}}})])}
var staticRenderFns = []

export { render, staticRenderFns }